<template>
  <div class="empty-content">
    <div class="empty-content__icon">
      <svg-icon :type="content.icon" />
    </div>
    <div class="empty-content__title">{{ content.title }}</div>
    <!--<div class="empty-content__txt">-->
      <!--{{ content.text }}-->
    <!--</div>-->
  </div>
</template>

<script>
export default {
  name: 'EmptyContent',
  props: {
    content: Object
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/variables";
  .empty-content {
    display: block;
    text-align: center;
    padding-top: 15px;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 25px;

    &__icon {
      color: #8ba2b6;
      font-size: 55px;
      margin-bottom: 15px;
      line-height: 1em;
    }

    &__title {
      display: block;
      color: #3b5e7b;
      opacity: .9;
      margin-bottom: 15px;
      font-weight: 800;
      font-size: 20px;
    }

    &__txt {
      display: block;
      color: #3b5e7b;
      font-size: 16px;
      margin-bottom: 15px;
    }

    &__buttons {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-bottom: 15px;
      margin-top: 35px;
    }

    &__button {
      color: #4c6b88;
      margin: 0 0 15px 15px;
      padding: 10px 30px;

      &:first-child {
        margin-left: 0;
      }

      &:hover {
        color: #4445a0 !important;
      }

      @include bp(mobile) {
        padding: 10px 30px;
        min-width: 250px;
        margin: 0 0 15px 0;
        justify-content: flex-start;

        .button__txt {
          width: 100%;
          text-align: center;
          justify-content: center;
        }

      }

      .button__icon {
        font-size: 22px;
      }
      .icon-font {
        margin-right: 10px;
        font-size: 22px;
      }

      .btn-txt {
        display: block;
      }

    }

    a:not(.button) {
      color: #4445a0;
      border-bottom: 1px solid;
    }

  }
</style>
